import { useEffect, useState } from "react";

export default function useSticky(customStickElementName = "") {
  const [sticky, setSticky] = useState(false);
  useEffect(() => {
    let offset: number;

    function getOffset() {
      let customStickPoint;
      // Get the absolute Y position of a specified element to act as the sticky trigger
      if (customStickElementName) {
        const customElement = document.querySelector(customStickElementName);
        if (customElement) {
          customStickPoint =
            customElement.getBoundingClientRect().top + window.scrollY;
        }
      }

      // Default sticky trigger is the first h1 element OR 300px
      const firstH1Rect = document.querySelector("h1")?.getBoundingClientRect();
      offset =
        customStickPoint ??
        (firstH1Rect ? firstH1Rect.bottom + window.scrollY : 300);

      if (window.location.pathname === "/") {
        // Limits the offset to at most 70% of viewport height
        offset = Math.min(offset, window.innerHeight * 0.7);
      }
      onScroll();
    }

    function onScroll() {
      setSticky(window.scrollY > offset);
    }

    getOffset();

    window.addEventListener("resize", getOffset, { passive: true });
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("topleaderboard_resize", getOffset, {
      passive: true,
    });
    return () => {
      window.removeEventListener("resize", getOffset);
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("topleaderboard_resize", onScroll);
    };
  }, [customStickElementName]);

  return { sticky };
}
